import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountLatestUnderwritingQueryKey } from "../account.keys";

export const useAdminFetchLatestSuretyAccountUnderwriting = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isFetching, isLoading, refetch } = useQuery({
		queryKey: accountLatestUnderwritingQueryKey(accountId),
		queryFn: () =>
			get<Dtos.Admin.Account.Underwriting.Get.Response | null>(
				`/v2/admin/surety/accounts/${accountId}/underwritings/latest`,
			),
		retry: false,
		meta: { suppressErrorModal: true },
	});

	return {
		latestUnderwriting: data,
		latestUnderwritingError: error,
		latestUnderwritingIsFetching: isFetching,
		latestUnderwritingIsLoading: isLoading,
		refetchLatestUnderwriting: refetch,
	};
};
